import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import FamilyRestroomTwoToneIcon from '@mui/icons-material/FamilyRestroomTwoTone';
import SchoolTwoToneIcon from '@mui/icons-material/SchoolTwoTone';
import ChildCareTwoToneIcon from '@mui/icons-material/ChildCareTwoTone';
import LocalOfferTwoToneIcon from '@mui/icons-material/LocalOfferTwoTone';

import { getChildCampusName } from '../../utils/parentHistoryHelpers';

const ParentDetails = (props) => {
  const childrenCount = props.childrens?.length || 0;

  // Campuses the children attend other than the primary one (multi-campus families).
  const otherCampuses = [
    ...new Set((props.childrens || []).map(getChildCampusName).filter(Boolean)),
  ].filter((name) => name !== props.college);

  return (
    <Box
      sx={{
        width: '100%',
        mb: 3,
        p: { xs: 2, sm: 2.5 },
        borderRadius: '16px',
        background: 'linear-gradient(135deg, #ECFDF5 0%, #F0FDF4 100%)',
        border: '1px solid #A7F3D0',
        boxShadow: '0 4px 20px rgba(5, 150, 105, 0.06)',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5
      }}
    >
      {/* Top Row: Family Title & Parent ID Badge */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: '50%',
              bgcolor: '#059669',
              color: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(5, 150, 105, 0.3)'
            }}
          >
            <FamilyRestroomTwoToneIcon sx={{ fontSize: 22 }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 800,
              color: '#065F46',
              fontSize: { xs: '1.05rem', sm: '1.25rem' },
              letterSpacing: '-0.01em'
            }}
          >
            {props.famName || 'Family Account'}
          </Typography>
        </Box>

        <Chip
          label={`Parent ID: ${props.ParentID || ''}`}
          size="small"
          sx={{
            bgcolor: '#FFFFFF',
            color: '#047857',
            fontWeight: 700,
            fontSize: '12px',
            border: '1px solid #A7F3D0',
            px: 0.5
          }}
        />
      </Box>

      {/* Info Pills Stack */}
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
        {props.college && (
          <Chip
            icon={<SchoolTwoToneIcon style={{ color: '#059669', fontSize: 16 }} />}
            label={`Campus: ${props.college}`}
            size="small"
            sx={{ bgcolor: '#FFFFFF', color: '#166534', fontWeight: 600, fontSize: '12px', border: '1px solid #D1FAE5' }}
          />
        )}
        {otherCampuses.map((campus) => (
          <Chip
            key={campus}
            icon={<SchoolTwoToneIcon style={{ color: '#0EA5E9', fontSize: 16 }} />}
            label={`Also at: ${campus}`}
            size="small"
            sx={{ bgcolor: '#FFFFFF', color: '#075985', fontWeight: 600, fontSize: '12px', border: '1px solid #BAE6FD' }}
          />
        ))}
        <Chip
          icon={<ChildCareTwoToneIcon style={{ color: '#2563EB', fontSize: 16 }} />}
          label={`${childrenCount} ${childrenCount > 1 ? 'Children' : 'Child'}`}
          size="small"
          sx={{ bgcolor: '#FFFFFF', color: '#1E40AF', fontWeight: 600, fontSize: '12px', border: '1px solid #DBEAFE' }}
        />
        {props.DiscountValue && props.DiscountValue !== 'No Discount' && (
          <Chip
            icon={<LocalOfferTwoToneIcon style={{ color: '#D97706', fontSize: 16 }} />}
            label={props.DiscountValue}
            size="small"
            sx={{ bgcolor: '#FEF3C7', color: '#92400E', fontWeight: 600, fontSize: '12px', border: '1px solid #FDE68A' }}
          />
        )}
      </Stack>
    </Box>
  );
};

export default ParentDetails;
